import { Type } from 'class-transformer';
import { VendorContractResultDto } from './vendor-contract-result-dto';

export class ManageVendorContractResultDto {
    @Type(() => VendorContractResultDto)
    vendorContracts: VendorContractResultDto[];

    allowAddVendorContract: boolean;
    allowActions: boolean;
}
